import { useEffect, useState } from "react";
import {
    Field, Input, Label,
    TableRowProduct, TextArea, Dropdown, Item,
    Sup
} from "../../styles/common";
import { useDispatch, useSelector } from "react-redux";
import { ComponentUpdate } from "../../store/slices/component";
import { GetBrands, GetCategories, GetProductByIdApi, GetSubCategories, GetSubSubCategories, ProductColorList } from "../../common/CommonApi";
import { getHSNDetails } from "../../common/common";
import Swal from "sweetalert2";
import _ from 'lodash'
import { AddColor } from "./AddColor";
import { AddSize } from "./AddSize";
import styled from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AlertCircle, ArrowLeft, CheckCircle2, ImagePlus, Plus, Trash2 } from "lucide-react";

export const AddProduct = ({ editMode = false }) => {
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [subsubCategories, setSubSubCategories] = useState([]);
    const [step, setStep] = useState(1);
    const dispatch = useDispatch();
    const [brands, setBrands] = useState([]);
    const [color, setColor] = useState([]);
    const [size, setSize] = useState([]);
    const [brandsId, setBrandsId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState('');
    const [hsnSuggestion, setHsnSuggestion] = useState(null);
    const [hsnLoading, setHsnLoading] = useState(false);
    const [hsnApplied, setHsnApplied] = useState(false);
    const userProfile = useSelector((state) => state.auth);
    const componentStores = useSelector((state) => state.component);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const productId = searchParams.get("id");
    const [editingDraft, setEditingDraft] = useState(false);


    const [productItem, setProductItem] = useState({
        name: '',
        description: '',
        category: '',
        subcategory: '',
        subsubcategory: '',
        price: 0,
        disCountedprice: 0,
        // images: '',
        brandsId: '',
        season: '',
        careInstructions: '',
        styleTags: '',
        HsnTaxCode: '',
        hsnDescription: '',
        gstRate: '',
        trynbuy:true,
        originBy:'',
        
        occasion:'',
        material:'',
        sleevetype:'',
        necktype:'',
        pattern:'',
        fittype:'',
        pickup:'',
        attributes: {},

        variants: [
            {
                size: "",
                color: "",
                material: "",
                quantity: "",
                // sku: "",
                varientImages: [],
                usePreviousData: false,
                price: 0,
                disCountedprice: 0,
            }
        ]
    });


useEffect(() => {
    const initializeForm = async () => {
        await getBrandsList();

        if (editMode && productId) {
            await loadProductForEdit(productId);
        } else {
            await getCategory();
        }
    };

    initializeForm();

    dispatch(
        ComponentUpdate({
            isSideBar: true,
            isHeaderBar: false,
            isProductModelOpen: true,
        })
    );
}, []);


useEffect(() => {
    if (componentStores.refreshColorList) {
        getBrandsList();
    }
}, [componentStores.refreshColorList]);


useEffect(() => {
    const code = productItem.HsnTaxCode?.trim();
    setHsnApplied(false);

    if (!code || code.length < 4) {
        setHsnSuggestion(null);
        return;
    }

    const timer = setTimeout(async () => {
        setHsnLoading(true);
        try {
            const details = await getHSNDetails(code);
            setHsnSuggestion(details);
        } catch (error) {
            setHsnSuggestion(null);
        } finally {
            setHsnLoading(false);
        }
    }, 400);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [productItem.HsnTaxCode]);

const applyHsnSuggestion = () => {
    if (!hsnSuggestion) return;
    setProductItem((prev) => ({
        ...prev,
        HsnTaxCode: hsnSuggestion.hsnCode,
        hsnDescription: hsnSuggestion.description,
        gstRate: hsnSuggestion.gstRate ?? '',
    }));
    setHsnSuggestion(null);
    setHsnApplied(true);
};



const getCategory = async (preferred = {}) => {
    try {
        const data = await GetCategories();
        const list = data?.data?.data || [];

        setCategories(list);

        const categoryId =
            list.find((item) => item._id === preferred.category)?._id ||
            list.find((item) => item._id === productItem.category)?._id ||
            list[0]?._id ||
            "";

        setProductItem((prev) => ({
            ...prev,
            category: categoryId,
        }));

        if (categoryId) {
            await GetSubCategorie(
                categoryId,
                preferred.subcategory,
                preferred.subsubcategory
            );
        }
    } catch (error) {
        console.error("Error fetching categories:", error);
    }
};

const GetSubCategorie = async (categoryID, preferredSubcategory = "", preferredSubsubcategory = "") => {
    if (!categoryID) return;

    try {
        const data = await GetSubCategories(categoryID);
        const list = data?.data?.data || [];

        setSubCategories(list);

        const subcategoryId =
            list.find((item) => item._id === preferredSubcategory)?._id ||
            list.find((item) => item._id === productItem.subcategory)?._id ||
            list[0]?._id ||
            "";

        setProductItem((prev) => ({
            ...prev,
            subcategory: subcategoryId,
        }));

        if (subcategoryId) {
            await getSubSubCategory(
                subcategoryId,
                categoryID,
                preferredSubsubcategory
            );
        }
    } catch (error) {
        console.error("Error fetching subcategories:", error);
    }
};

const getSubSubCategory = async (subcategoryID, categoryID, preferredSubsubcategory = "") => {
    console.log("----1")
    if (!subcategoryID || !categoryID) return;
console.log("----1",subcategoryID,categoryID)
    try {
        const data = await GetSubSubCategories(
            subcategoryID,
            categoryID
        );

        console.log("----1data",data)

        const list = data?.data?.data || [];

        setSubSubCategories(list);

        setProductItem((prev) => {
            const selectedSubsubcategory =
                list.find((item) => item._id === preferredSubsubcategory) ||
                list.find((item) => item._id === prev.subsubcategory) ||
                list[0];
            const attributeKeys = selectedSubsubcategory?.attributeKeys || [];

            return {
                ...prev,
                subsubcategory: selectedSubsubcategory?._id || "",
                attributes: Object.fromEntries(
                    attributeKeys.map((key) => [key, prev.attributes?.[key] || ""])
                ),
            };
        });
    } catch (error) {
        console.error("Error fetching sub-sub-categories:", error);
    }
};

const loadProductForEdit = async (id) => {
    try {
        const response = await GetProductByIdApi(id);
        if (response?.data?.message !== "DATA_FOUND") {
            throw new Error(response?.data?.message || "Product could not be loaded.");
        }

        const product = response.data.data;
        const categoryId = String(product.category?._id || product.category || "");
        const subcategoryId = String(product.subcategory?._id || product.subcategory || "");
        const subsubcategoryId = String(product.subsubcategory?._id || product.subsubcategory || "");
        const brandId = String(product.brandsId?._id || product.brandsId || "");

        await getCategory({
            category: categoryId,
            subcategory: subcategoryId,
            subsubcategory: subsubcategoryId,
        });

        setBrandsId(brandId);
        setEditingDraft(Boolean(product.isDraft));
        setProductItem((prev) => ({
            ...prev,
            ...product,
            category: categoryId,
            subcategory: subcategoryId,
            subsubcategory: subsubcategoryId,
            brandsId: brandId,
            attributes: product.attributes || {},
            variants: (product.variants || []).length
                ? product.variants.map((variant) => ({
                    ...variant,
                    varientImages: variant.varientImages || [],
                    usePreviousData: false,
                }))
                : prev.variants,
        }));
    } catch (error) {
        showError(error?.response?.data?.message || error?.message || "Product could not be loaded.");
    }
};

    const getProductDetailErrors = (data) => {
        const errors = [];

        if (!data.name?.trim()) errors.push('Product title');
        if (!data.description?.trim()) errors.push('Description');
        if (!data.category) errors.push('Main category');
        if (!data.subcategory) errors.push('Sub category');
        if (!data.subsubcategory) errors.push('Sub-sub category');
        if (!(data.brandsId || brandsId)) errors.push('Brand');
        if (!data.HsnTaxCode?.trim()) errors.push('HSN / Tax code');
        if (!data.originBy?.trim()) errors.push('Country of Origin');
        if (!data.careInstructions?.trim()) errors.push('Care Instructions');

        return errors;
    };

    const getVariantErrors = (data) => {
        if (!data.variants?.length) return ['At least one variant'];

        return data.variants.flatMap((variant, index) => {
            const errors = [];
            const label = `Variant ${index + 1}`;

            if (_.isEmpty(variant.size)) errors.push(`${label} size`);
            if (!variant.quantity || Number(variant.quantity) <= 0) {
                errors.push(`${label} stock quantity`);
            }
            if (!variant.price || Number(variant.price) <= 0) {
                errors.push(`${label} price`);
            }
            const discountedPrice = Number(variant.disCountedprice);
            const regularPrice = Number(variant.price);

            if (discountedPrice < 0) {
                errors.push(`${label} discounted price cannot be negative`);
            } else if (discountedPrice > regularPrice) {
                errors.push(`${label} discounted price cannot be more than MRP`);
            }

            return errors;
        });
    };

    const showError = (message) => {
        setFormError(message);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        Swal.fire({
            icon: 'error',
            title: 'Please check the product',
            text: message,
        });
    };

    const handleProduct = (e, index = null) => {
        const { name, value, type, checked, files } = e.target;

        if (name === "category") {
    setProductItem((prev) => ({
        ...prev,
        category: value,
        subcategory: "",
        subsubcategory: "",
        attributes: {},
    }));

    GetSubCategorie(value);
    return;
}

        if (name === "subcategory") {
            setProductItem((prev) => ({
                ...prev,
                subcategory: value,
                subsubcategory: "",
                attributes: {},
            }));

            getSubSubCategory(value, productItem.category);
            return;
        }
        if (name === "subsubcategory") {
            const selectedSubsubcategory = subsubCategories.find((item) => item._id === value);
            const attributeKeys = selectedSubsubcategory?.attributeKeys || [];

            setProductItem((prev) => ({
                ...prev,
                subsubcategory: value,
                attributes: Object.fromEntries(
                    attributeKeys.map((key) => [key, prev.attributes?.[key] || ""])
                ),
            }));
            return;
        }
        if (name === "price" || name === "disCountedprice") {
            setProductItem((prev) => ({
            ...prev,
            [name]: parseFloat(value) || 0,
            }));
        } else if (name.startsWith("variants.") && index !== null) {
            const key = name.split(".")[1];
            const updatedVariants = [...productItem.variants];

            updatedVariants[index][key] =
            key === "quantity" ? parseInt(value) || 0 : value;

            setProductItem((prev) => ({
            ...prev,
            variants: updatedVariants,
            }));
        } else {
            setProductItem((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                ? checked
                : type === "file"
                ? files
                : value === "true"
                ? true
                : value === "false"
                ? false
                : value,
            }));
        }
        };

    const handleAttributeChange = (attributeKey, value) => {
        setProductItem((prev) => ({
            ...prev,
            attributes: {
                ...(prev.attributes || {}),
                [attributeKey]: value,
            },
        }));
    };

    const selectedAttributeKeys =
        subsubCategories.find((item) => item._id === productItem.subsubcategory)?.attributeKeys || [];

    const createDefaultVariant = () => ({
    size: size[0] || "",
    color: color[0] || "",
    quantity: "",
    // sku: "",
    price: 0,
    disCountedprice: 0,
    varientImages: [],
    usePreviousData: false
});
    
    const addVariant = () => {
        setProductItem((prev) => ({
            ...prev,
            variants: [...prev.variants, createDefaultVariant()],
        }));
    };

    const removeVariant = (index) => {
        setProductItem((prev) => ({
            ...prev,
            variants: prev.variants.filter((_, i) => i !== index)
        }));
    };


    const getBrandsList = async () => {
        let brands = await GetBrands(userProfile?._id)
        if (brands.data.message === 'brands retrieved successfully') {
            const list = brands.data.data;
            setBrands(list)
            setBrandsId((prev) => (list.some((b) => b._id === prev) ? prev : list[0]?._id));
        }
        const productsUser = await ProductColorList(userProfile._id);
        // console.log("productsUser?.data.data?.color",productsUser?.data.data?.color)
        setColor(productsUser?.data.data?.color)
        // console.log("productsUser?.data.data?.color", productsUser?.data.data?.color[0])
        setSize(productsUser?.data.data?.size)
        setProductItem((prev) => ({
            ...prev,

            variants: prev.variants.map(
                (variant, index) => ({
                    ...variant,

                    size:
                        variant.size ||
                        (index === 0
                            ? productsUser?.data?.data?.size?.[0] || ""
                            : ""),

                    color:
                        variant.color ||
                        (index === 0
                            ? productsUser?.data?.data?.color?.[0] || ""
                            : ""),
                })
            ),
        }));
    }

  const handleBrands = (e) => {
    const value = e.target.value;

    setBrandsId(value);

    setProductItem((prev) => ({
        ...prev,
        brandsId: value,
    }));
};

    const handleSubmitProduct = async (e, saveAsDraft = false) => {
        e?.preventDefault();
        const productDetailErrors = saveAsDraft ? [] : getProductDetailErrors(productItem);
        const variantErrors = saveAsDraft ? [] : getVariantErrors(productItem);
        const validationErrors = [...productDetailErrors, ...variantErrors];

        if (validationErrors.length > 0) {
            if (productDetailErrors.length > 0) setStep(1);
            showError(`Please complete: ${validationErrors.join(', ')}.`);
            return;
        }

        setFormError('');
        setIsSubmitting(true);
        const formData = new FormData();
            formData.append("name", productItem.name);
            formData.append("description", productItem.description);
            if (productItem.category) formData.append("category", productItem.category);
            formData.append("trynbuy", productItem.trynbuy);
            formData.append("originBy", productItem.originBy);
            formData.append(
                "variants",
                JSON.stringify(
                    productItem.variants.map(v => ({
                        ...v,
                        inheritedImages: v.usePreviousData, // ✅ ADD THIS
                        varientImages: (v.varientImages || []).filter(
                            (image) => typeof image === "string"
                        )
                    }))
                )
            );
            // productItem.variants.forEach((variant, index) => {
            //     variant.varientImages?.forEach((file) => {
            //         formData.append(`variantImages_${index}`, file);
            //     });
            // });
            productItem.variants.forEach((variant, index) => {

                // ✅ if copied variant → don't upload images again
                if (variant.usePreviousData) return;

                variant.varientImages?.forEach((file) => {
                    if (typeof file !== "string") {
                        formData.append(`variantImages_${index}`, file);
                    }
                });
            });
            if (productItem.subcategory) formData.append("subCategory", productItem.subcategory);
            if (productItem.subsubcategory) formData.append("subsubcategory", productItem.subsubcategory);
            if (brandsId) formData.append("brandsId", brandsId);
            formData.append("adminId", productItem.adminId || userProfile?._id);
            formData.append("isDraft", String(saveAsDraft));
            formData.append("HsnTaxCode", productItem?.HsnTaxCode);
            formData.append("hsnDescription", productItem?.hsnDescription || '');
            if (productItem?.gstRate !== '' && productItem?.gstRate != null) {
                formData.append("gstRate", productItem.gstRate);
            }
            formData.append("season", productItem?.season);
            formData.append("careInstructions", productItem?.careInstructions);
            formData.append("styleTags", productItem?.styleTags);
            
            formData.append("occasion", productItem?.occasion);
            formData.append("material", productItem?.material);
            formData.append("sleevetype", productItem?.sleevetype);
            formData.append("necktype", productItem?.necktype);
            formData.append("pattern", productItem?.pattern);
            formData.append("fittype", productItem?.fittype);
            formData.append("pickup", productItem?.pickup);
            formData.append("attributes", JSON.stringify(productItem.attributes || {}));

            const attributeValues = productItem.attributes || {};
            if (attributeValues.Material || attributeValues.Fabric) {
                formData.set("material", attributeValues.Material || attributeValues.Fabric);
            }
            if (attributeValues.Occasion) formData.set("occasion", attributeValues.Occasion);
            if (attributeValues.Season) formData.set("season", attributeValues.Season);
            if (attributeValues.Pattern) formData.set("pattern", attributeValues.Pattern);
            if (attributeValues.Fit) formData.set("fittype", attributeValues.Fit);
            if (attributeValues["Sleeve Type"]) formData.set("sleevetype", attributeValues["Sleeve Type"]);
            if (attributeValues["Neck Type"]) formData.set("necktype", attributeValues["Neck Type"]);

            try {
                const endpoint = editMode
                    ? `products/update/${productId}`
                    : "products";
                const response = await fetch(process.env.REACT_APP_API_URL + endpoint, {
                    method: editMode ? "PUT" : "POST",
                    body: formData,
                });
                let data = null;

                try {
                    data = await response.json();
                } catch {
                    // The HTTP status below still provides a useful error for non-JSON responses.
                }

                const expectedMessage = editMode
                    ? "SUCCESSFULLY_UPDATED"
                    : "SUCCESS_FULLY_CREATED";

                if (response.ok && data?.message === expectedMessage) {
                    setFormError('');
                    dispatch(ComponentUpdate({ isProductModelOpen: false }))
                    await Swal.fire({
                        icon: "success",
                        title: saveAsDraft
                            ? "Draft saved"
                            : editMode
                              ? "Product updated"
                              : "Product added",
                        text: saveAsDraft
                            ? "The product has been saved in Drafts."
                            : editMode
                              ? "The product has been updated successfully."
                              : "The product has been added successfully.",
                        confirmButtonText: "Back to products",
                    });
                    navigate(saveAsDraft ? "/products?tab=drafts" : "/products");
                } else {
                    throw new Error(
                        data?.message || `Unable to add the product (HTTP ${response.status}).`
                    );
                }
                // console.log("Success:", data);
            } catch (err) {
                console.error("Error:", err);
                const message = err?.message === 'Failed to fetch'
                    ? 'Could not connect to the server. Check your connection and try again.'
                    : err?.message || 'Something went wrong while adding the product.';
                showError(message);
            } finally {
                setIsSubmitting(false);
            }
    };

    const handleNext = () => {
        const errors = getProductDetailErrors(productItem);

        if (errors.length > 0) {
            showError(`Please complete: ${errors.join(', ')}.`);
            return;
        }

        setFormError('');
        setStep(2);
    };
    const handleBack = () => setStep((prev) => prev - 1);


    const handleVariantImageChange = (e, index) => {
    const files = Array.from(e.target.files);

    setProductItem((prev) => {
        const updatedVariants = [...prev.variants];
        const existingFiles = updatedVariants[index].varientImages || [];

        // Filter out duplicates by name + size
        const newUniqueFiles = files.filter(
        (f) => !existingFiles.some((ef) => ef.name === f.name && ef.size === f.size)
        );

        updatedVariants[index].varientImages = [...existingFiles, ...newUniqueFiles];
        return { ...prev, variants: updatedVariants };
    });
    };

    const handleDeleteVariantImage = (variantIndex, imageIndex) => {
    setProductItem((prev) => {
        const updatedVariants = [...prev.variants];
        updatedVariants[variantIndex].varientImages.splice(imageIndex, 1);
        return { ...prev, variants: updatedVariants };
    });
    };
    

const handleUsePreviousData = (index) => {

    setProductItem(prev => {

        const newVariants = prev.variants.map((variant, i) => {

            if (i !== index) return variant;

            const checked = !variant.usePreviousData;

            // uncheck
            if (!checked) {
                return {
                    ...variant,
                    usePreviousData: false
                };
            }

            // ✅ copy ONLY DATA (NO IMAGES)
            if (checked && index > 0) {
                const previous = prev.variants[index - 1];

                return {
                    ...variant,
                    usePreviousData: true,
                    quantity: previous.quantity,
                    price: previous.price,
                    disCountedprice: previous.disCountedprice,
                    // sku: previous.sku,
                    material: previous.material,
                    color:previous.color,

                    // ✅ IMPORTANT — REMOVE IMAGES
                    varientImages: []
                };
            }

            return variant;
        });

        return {
            ...prev,
            variants: newVariants
        };
    });
};
    return (
        <AddProductPage>
            {componentStores.isSize && <AddSize />}
            {componentStores.isColor && <AddColor />}

            <AddProductHeader>
                <HeaderCopy>
                    <BackButton type="button" onClick={() => navigate("/products")}>
                        <ArrowLeft size={18} />
                        Products
                    </BackButton>
                    <h1>{editMode ? "Edit Product" : "Add Product"}</h1>
                    <p>{editMode
                        ? "Update product information, merchandising details, and inventory variants."
                        : "Build product information, merchandising details, and inventory variants."}</p>
                </HeaderCopy>
                <StepIndicator>
                    <StepPill $active={step === 1} $complete={step > 1}>
                        <span>{step > 1 ? <CheckCircle2 size={15} /> : "1"}</span>
                        Product details
                    </StepPill>
                    <StepDivider />
                    <StepPill $active={step === 2}>
                        <span>2</span>
                        Variants
                    </StepPill>
                </StepIndicator>
            </AddProductHeader>

            {formError && (
                <ErrorBanner role="alert" aria-live="assertive">
                    <AlertCircle size={20} />
                    <div>
                        <strong>Product could not be saved</strong>
                        <span>{formError}</span>
                    </div>
                </ErrorBanner>
            )}

            {/* STEP 1 */}
            {step === 1 && (
                <FormPanel>
                    <SectionHeader>
                        <h2>Classification</h2>
                        <p>Choose where this product appears in the catalog.</p>
                    </SectionHeader>
                    <TableRowProduct cols={4}>
                        <Field>
                            <Label>Main Category<Sup>*</Sup></Label>
                            <Dropdown
                                name="category"
                                value={productItem.category}
                                onChange={handleProduct}
                            >
                                {
                                    categories.map((data) => {
                                        return (<Item value={data._id}>{data.categoryName}</Item>)
                                    })
                                }
                            </Dropdown>
                        </Field>
                        <Field>
                            <Label>Sub Category<Sup>*</Sup></Label>
                            <Dropdown
                                name="subcategory"
                                value={productItem.subcategory}
                                onChange={handleProduct}
                            >
                                {
                                    subCategories.map((data) => {
                                        return (<Item value={data._id}>{data.subcategoryName}</Item>)
                                    })
                                }
                            </Dropdown>
                        </Field>
                        <Field>
                                <Label>
                                    Sub-Sub Category<Sup>*</Sup>
                                </Label>

                                <Dropdown
                                    name="subsubcategory"
                                    value={productItem.subsubcategory || ""}
                                    onChange={handleProduct}
                                >
                                    {subsubCategories.map((data) => (
                                        <Item key={data._id} value={data._id}>
                                            {data.subcategoryName}
                                        </Item>
                                    ))}
                                </Dropdown>
                            </Field>
                        <Field>
                            <Label>Brand<Sup>*</Sup></Label>
                            <Dropdown
                                 name="brandsId"
                                value={productItem.brandsId || brandsId}
                                onChange={handleBrands}
                            >
                                {
                                    brands.map((data) => {
                                        return (<Item value={data._id}>{data.brandName}</Item>)
                                    })
                                }
                            </Dropdown>
                        </Field>
                    </TableRowProduct>
                    <SectionHeader>
                        <h2>Product Information</h2>
                        <p>Add customer-facing product copy and attributes.</p>
                    </SectionHeader>
                    <TableRowProduct cols={2}>
                        <Field>
                            <Label>Product Title<Sup>*</Sup></Label>
                            <Input name="name"
                                onChange={handleProduct}
                                value={productItem.name}
                            />
                        </Field>
                        <Field>
                            <Label>Description<Sup>*</Sup></Label>
                            <TextArea name="description"
                                onChange={handleProduct}
                                value={productItem.description}
                            />
                        </Field>

                        {selectedAttributeKeys.length > 0 && (
                            <DynamicAttributesSection>
                                <DynamicAttributeHeader>
                                    <h3>Category Attributes</h3>
                                    <p>Enter the values configured for the selected sub-sub-category.</p>
                                </DynamicAttributeHeader>
                                <TableRowProduct cols={4}>
                                    {selectedAttributeKeys.map((attributeKey) => (
                                        <Field key={attributeKey}>
                                            <Label>{attributeKey}</Label>
                                            <Input
                                                value={productItem.attributes?.[attributeKey] || ""}
                                                onChange={(event) => handleAttributeChange(attributeKey, event.target.value)}
                                                placeholder={`Enter ${attributeKey}`}
                                            />
                                        </Field>
                                    ))}
                                </TableRowProduct>
                            </DynamicAttributesSection>
                        )}

                        <Field>
                                <Label>HSN / Tax Code<Sup>*</Sup></Label>
                                <HsnFieldWrapper>
                                    <Input name="HsnTaxCode"
                                        onChange={handleProduct}
                                        value={productItem.HsnTaxCode}
                                        placeholder="e.g. 8517"
                                        autoComplete="off"
                                    />
                                    {hsnLoading && <HsnAppliedNote>Looking up HSN code…</HsnAppliedNote>}
                                    {!hsnLoading && hsnSuggestion && (
                                        <HsnSuggestionCard>
                                            <HsnSuggestionHeader>
                                                <HsnSuggestionCode>{hsnSuggestion.hsnCode}</HsnSuggestionCode>
                                                {hsnSuggestion.gstRate != null && (
                                                    <HsnSuggestionRate>GST {hsnSuggestion.gstRate}%</HsnSuggestionRate>
                                                )}
                                            </HsnSuggestionHeader>
                                            {hsnSuggestion.description && (
                                                <HsnSuggestionDescription>{hsnSuggestion.description}</HsnSuggestionDescription>
                                            )}
                                            <HsnSuggestionApplyButton type="button" onClick={applyHsnSuggestion}>
                                                Use this
                                            </HsnSuggestionApplyButton>
                                        </HsnSuggestionCard>
                                    )}
                                    {hsnApplied && productItem.gstRate !== '' && (
                                        <HsnAppliedNote>
                                            Applied — GST {productItem.gstRate}%{productItem.hsnDescription ? ` · ${productItem.hsnDescription}` : ''}
                                        </HsnAppliedNote>
                                    )}
                                </HsnFieldWrapper>
                        </Field>

                        <Field>
                            <Label>Style Tags / Keywords</Label>
                            <TextArea name="styleTags"
                                onChange={handleProduct}
                                value={productItem.styleTags}
                            />
                        </Field>
                        <Field>
                            <Label>Care Instructions<Sup>*</Sup></Label>
                            <TextArea name="careInstructions"
                                onChange={handleProduct}
                                value={productItem.careInstructions}
                            />
                        </Field>
                        <Field>
                             <Label>Try and Buy</Label>
                              <Dropdown
                                name="trynbuy"
                                value={String(productItem.trynbuy)}
                                onChange={handleProduct}
                            >
                                <Item value="false">No</Item>
                                <Item value="true">Yes</Item>
                            </Dropdown>
                        </Field>
                        <Field>
                                <Label>Country of Origin<Sup>*</Sup></Label>
                                <Input name="originBy"
                                    onChange={handleProduct}
                                    value={productItem.originBy}
                                />
                        </Field>
                            {/* <Field>
                                <Label>Store/pickup location</Label>
                                <Input name="pickup"
                                    onChange={handleProduct}
                                    value={productItem.pickup}
                                />
                            </Field> */}
                        {/* <Field>
                            <Label>Price<Sup>*</Sup></Label>
                            <Input
                                name="price"
                                onChange={handleProduct}
                                value={productItem.price}
                            />
                        </Field> */}

                        {/* <Field>
                            <Label>Compare at Price</Label>
                            <Input
                                name="disCountedprice"
                                onChange={handleProduct}
                                value={productItem.disCountedprice}
                            />
                        </Field> */}
                    </TableRowProduct>
                    <FooterActions>
                        <SecondaryButton type="button" onClick={() => navigate("/products")}>
                            Cancel
                        </SecondaryButton>
                        {(!editMode || editingDraft) && (
                            <SecondaryButton
                                type="button"
                                onClick={(e) => handleSubmitProduct(e, true)}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Saving..." : "Save as Draft"}
                            </SecondaryButton>
                        )}
                        <PrimaryButton type="button" onClick={handleNext}>
                            Next
                        </PrimaryButton>
                    </FooterActions>
                </FormPanel>
            )}

            {/* STEP 2 */}
            {step === 2 && (
                <FormPanel>
                    <SectionHeader $row>
                        <div>
                            <h2>Variants</h2>
                            <p>Add prices, stock, size, color, and images for each variant.</p>
                        </div>
                        <VariantTools>
                        <ToolButton type="button"
                            onClick={() => dispatch(ComponentUpdate({ isColor: true, isProductModelOpen: true }))}
                        ><Plus size={16} /> Color</ToolButton>
                        <ToolButton type="button"
                            onClick={() => dispatch(ComponentUpdate({ isSize: true, isProductModelOpen: true }))}
                        ><Plus size={16} /> Size</ToolButton>
                        </VariantTools>
                    </SectionHeader>
                    <VariantList>
                        <RequiredNote>At least one variant is required.</RequiredNote>
                        {productItem.variants.map((variant, index) => (
                            <VariantCard
                                key={index}
                            >
                                <VariantHeader>
                                    <h3>Variant {index + 1}</h3>
                                    {productItem.variants.length > 1 && (
                                        <IconButton
                                            type="button"
                                            onClick={() => removeVariant(index)}
                                            title="Remove variant"
                                            aria-label="Remove variant"
                                        >
                                            <Trash2 size={16} />
                                        </IconButton>
                                    )}
                                </VariantHeader>

                                {index > 0 && (
                                    <CloneRow>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={variant.usePreviousData || false}
                                                onChange={() => handleUsePreviousData(index)}
                                            />
                                            Clone previous variant details
                                        </label>
                                    </CloneRow>
                                )}
                                <VariantGrid>
                                    <Field>
                                        <Label>Stock Quantity<Sup>*</Sup></Label>
                                        <Input
                                            name="variants.quantity"
                                            onChange={(e) => handleProduct(e, index)}
                                            value={variant.quantity}
                                        />
                                    </Field>
                                    <Field>
                                        <Label>MRP<Sup>*</Sup></Label>
                                        <Input
                                            type="number"
                                            min="0.01"
                                            step="0.01"
                                            name="variants.price"
                                            onChange={(e) => handleProduct(e, index)}
                                            value={variant.price}
                                        />
                                    </Field>
                                    <Field>
                                        <Label>Discounted Price</Label>
                                        <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            max={Number(variant.price) > 0 ? Number(variant.price) : undefined}
                                            name="variants.disCountedprice"
                                            onChange={(e) => handleProduct(e, index)}
                                            value={variant.disCountedprice}
                                        />
                                    </Field>

                                    {/* <Field>
                                        <Label>SKU<Sup>*</Sup></Label>
                                        <Input
                                            name="variants.sku"
                                            onChange={(e) => handleProduct(e, index)}
                                            value={variant.sku}
                                        />
                                    </Field> */}
                                      {/* <Field>
                                        <Label>Material Fabric</Label>
                                        <Input
                                            name="variants.material"
                                            onChange={(e) => handleProduct(e, index)}
                                            value={variant.material}
                                        />
                                    </Field> */}
                                    <Field>
                                        <Label>Size<Sup>*</Sup></Label>
                                        <Dropdown
                                            name="variants.size"
                                            value={variant.size}
                                            onChange={(e) => handleProduct(e, index)}
                                        >
                                            {
                                                size.map((data) => {
                                                    return (<Item key={data} value={data}>{data}</Item>)
                                                })
                                            }
                                        </Dropdown>
                                    </Field>
                                    <Field>
                                        <Label>Color</Label>
                                        <Dropdown
                                            name="variants.color"
                                            disabled={variant.usePreviousData}   // ✅ ADD THIS
                                            value={variant.color}                // ✅ IMPORTANT
                                            onChange={(e) => handleProduct(e, index)}

                                        >
                                            {
                                                color.map((data) => {
                                                    return (<Item key={data} value={data}>{data}</Item>)
                                                })
                                            }
                                        </Dropdown>
                                    </Field>
                                    
                                    </VariantGrid>
                                   {!variant.usePreviousData && (
<VariantImageRow>

    {/* Hidden Input */}
    <input
        id={`file-upload-${index}`}
        type="file"
        multiple
        accept="image/*"
        onChange={(e) => handleVariantImageChange(e, index)}
        style={{ display: "none" }}
    />

    {/* Upload Box */}
    <UploadTile
        htmlFor={`file-upload-${index}`}
    >
        <ImagePlus size={20} />
        Upload images
    </UploadTile>

    {/* Images Horizontal Row */}
    {variant.varientImages?.length > 0 && (
        <ImagePreviewStrip>
            {variant.varientImages.map((file, imgIndex) => (
                <ImagePreview
                    key={imgIndex}
                >
                    <img
                        src={typeof file === "string" ? file : URL.createObjectURL(file)}
                        alt=""
                    />

                    <button
                        type="button"
                        onClick={() => handleDeleteVariantImage(index, imgIndex)}
                        aria-label="Remove image"
                    >
                        x
                    </button>
                </ImagePreview>
            ))}
        </ImagePreviewStrip>
    )}

</VariantImageRow>
)}
                            </VariantCard>
                        ))}

                        <AddVariantAction type="button" onClick={addVariant}>
                            <Plus size={16} />
                            Add more variant
                        </AddVariantAction>
                    </VariantList>
                    <FooterActions>
                        <SecondaryButton type="button" onClick={handleBack}>Back</SecondaryButton>
                        {(!editMode || editingDraft) && (
                            <SecondaryButton
                                type="button"
                                onClick={(e) => handleSubmitProduct(e, true)}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Saving..." : "Save as Draft"}
                            </SecondaryButton>
                        )}
                        <PrimaryButton type="button" onClick={handleSubmitProduct} disabled={isSubmitting}>
                            {isSubmitting
                                ? "Submitting..."
                                : editMode
                                  ? editingDraft
                                    ? "Submit Product"
                                    : "Update Product"
                                  : "Submit Product"}
                        </PrimaryButton>
                    </FooterActions>
                </FormPanel>
            )}

            {/* STEP 3 */}
            {/* {step === 3 && ( */}
                <>
                    {/* <TableRowProduct cols={2}>
                        <Field>
                            <Label>Season / Occasion</Label>
                            <Input name="season"
                                onChange={handleProduct}
                                value={productItem.season}
                            />
                        </Field>
                        <Field>
                            <Label>HSN / Tax Code<Sup>*</Sup></Label>
                            <Input name="HsnTaxCode"
                                onChange={handleProduct}
                                value={productItem.HsnTaxCode}
                            />
                        </Field>
                        <Field>
                            <Label>Style Tags / Keywords</Label>
                            <TextArea name="styleTags"
                                onChange={handleProduct}
                                value={productItem.styleTags}
                            />
                        </Field>
                        <Field>
                            <Label>Care Instructions</Label>
                            <TextArea name="careInstructions"
                                onChange={handleProduct}
                                value={productItem.careInstructions}
                            />
                        </Field>
                    </TableRowProduct> */}
                    {/* <ButtonRow>
                        <Button onClick={handleBack}>Back</Button>
                        <AddButton onClick={() => handleSubmitProduct()}>Submit</AddButton>
                    </ButtonRow> */}
                </>
            {/* )} */}

{/*
            {step === 4 && (
                <>
                    <TableRowProduct cols={1}>
                        <div style={{ textAlign: "center" }}>
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "10px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                }}
                            >
                                Upload Images <Sup>*</Sup>
                            </label>

                            <input
                                id="file-upload"
                                type="file"
                                name='image'
                                multiple
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: "none" }}
                            />


                            <label
                                htmlFor="file-upload"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    gap: "8px",
                                    cursor: "pointer",
                                    border: "2px dashed #94a3b8",
                                    borderRadius: "12px",
                                    padding: "40px 20px",
                                    background: "#f8fafc",
                                    color: "#64748b",
                                    fontSize: "14px",
                                    transition: "all 0.3s ease",
                                }}
                            >
                                <img
                                    src="./assets/upload.png"
                                    alt="upload"
                                    style={{ width: "40px", opacity: 0.7 }}
                                />
                                <span>Click to Upload</span>
                            </label>

                            {images.length > 0 && (
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        marginTop: "20px",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                    }}
                                >
                                    {images.map((file, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                position: "relative",
                                                width: "100px",
                                                height: "100px",
                                                borderRadius: "10px",
                                                overflow: "hidden",
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={`preview-${index}`}
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                onClick={() => setPreviewImage(URL.createObjectURL(file))}
                                            />
                                            <button
                                                onClick={() => handleDelete(index)}
                                                style={{
                                                    position: "absolute",
                                                    top: "5px",
                                                    right: "5px",
                                                    background: "rgba(0,0,0,0.6)",
                                                    border: "none",
                                                    color: "#fff",
                                                    borderRadius: "50%",
                                                    width: "24px",
                                                    height: "24px",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {previewImage && (
                                <div
                                    onClick={() => setPreviewImage(null)}
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100vw",
                                        height: "100vh",
                                        background: "rgba(0,0,0,0.7)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 9999,
                                        cursor: "pointer",
                                    }}
                                >
                                    <img
                                        src={previewImage}
                                        alt="Big Preview"
                                        style={{
                                            maxWidth: "80%",
                                            maxHeight: "80%",
                                            borderRadius: "12px",
                                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </TableRowProduct>
                    {/* <ButtonRow>
                        <Button onClick={handleBack}>Back</Button>
                        <AddButton onClick={() => handleSubmitProduct()}>Submit</AddButton>
                    </ButtonRow> 
                </>
            )}*/}
        </AddProductPage>
    );
};

const AddProductPage = styled.div`
    // max-width: 1180px;
    margin: 0 auto;
    padding: 6px 0 28px;
`;

const AddProductHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 24px;
    align-items: flex-start;
    margin-bottom: 20px;

    @media (max-width: 900px) {
        flex-direction: column;
    }
`;

const ErrorBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 18px;
    padding: 14px 16px;
    color: #991b1b;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;

    svg {
        flex: 0 0 auto;
        margin-top: 1px;
    }

    div {
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    strong {
        font-size: 14px;
    }

    span {
        font-size: 13px;
        line-height: 1.45;
    }
`;

const HeaderCopy = styled.div`
    h1 {
        color: #0f172a;
        font-size: 30px;
        line-height: 1.2;
        margin: 10px 0 6px;
    }

    p {
        color: #64748b;
        margin: 0;
        font-size: 14px;
    }
`;

const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 8px;
    padding: 9px 12px;
    cursor: pointer;
    font-weight: 600;

    &:hover {
        border-color: #30d5c8;
        color: #0f766e;
    }
`;

const StepIndicator = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);

    @media (max-width: 640px) {
        width: 100%;
        overflow-x: auto;
        justify-content: flex-start;
    }
`;

const StepPill = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ $active, $complete }) => ($active || $complete ? "#0f766e" : "#64748b")};
    font-weight: 700;
    font-size: 13px;
    white-space: nowrap;

    span {
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: ${({ $active, $complete }) => ($active || $complete ? "#ccfbf1" : "#f1f5f9")};
        color: ${({ $active, $complete }) => ($active || $complete ? "#0f766e" : "#64748b")};
    }
`;

const StepDivider = styled.div`
    width: 34px;
    height: 1px;
    background: #cbd5e1;
`;

const FormPanel = styled.div`
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
    overflow: hidden;

    ${TableRowProduct} {
        background: #fff;
        padding: 0 22px 18px;
        color: #334155;
        align-items: stretch;
    }

    ${TableRowProduct} ${TableRowProduct} {
        grid-column: 1 / -1;
        width: 100%;
        padding: 0;
        grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    }

    ${Field} {
        margin-bottom: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    ${Label} {
        min-height: 34px;
        display: flex;
        align-items: flex-end;
        color: #334155;
        font-size: 13px;
        font-weight: 700;
    }

    ${Input}, ${TextArea}, ${Dropdown} {
        width: 100%;
        box-sizing: border-box;
        min-height: 42px;
        border-color: #cbd5e1;
        color: #0f172a;
        background: #fff;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &:focus {
            outline: none;
            border-color: #30d5c8;
            box-shadow: 0 0 0 3px rgba(48, 213, 200, 0.16);
        }
    }

    ${TextArea} {
        min-height: 94px;
        resize: vertical;
    }

    @media (max-width: 1100px) {
        > ${TableRowProduct} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }

    @media (max-width: 700px) {
        > ${TableRowProduct},
        ${TableRowProduct} ${TableRowProduct} {
            grid-template-columns: 1fr;
            gap: 14px;
        }

        > ${TableRowProduct} {
            padding: 0 14px 16px;
        }

        ${Label} {
            min-height: auto;
            align-items: flex-start;
        }
    }
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: ${({ $row }) => ($row ? "center" : "flex-start")};
    justify-content: space-between;
    gap: 16px;
    padding: 22px 22px 16px;
    border-top: 1px solid #f1f5f9;

    &:first-child {
        border-top: 0;
    }

    h2 {
        color: #0f172a;
        font-size: 17px;
        margin: 0 0 4px;
    }

    p {
        color: #64748b;
        margin: 0;
        font-size: 13px;
    }

    @media (max-width: 560px) {
        align-items: stretch;
        flex-direction: column;
        padding: 18px 14px 12px;
    }
`;

const FooterActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 18px 22px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;

    @media (max-width: 480px) {
        flex-direction: column-reverse;
        padding: 14px;

        button {
            width: 100%;
        }
    }
`;

const BaseActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    border-radius: 8px;
    padding: 0 18px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const PrimaryButton = styled(BaseActionButton)`
    border: 1px solid #30d5c8;
    background: #30d5c8;
    color: #fff;

    &:hover:not(:disabled) {
        background: #26a79d;
        border-color: #26a79d;
    }
`;

const SecondaryButton = styled(BaseActionButton)`
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #334155;

    &:hover {
        border-color: #94a3b8;
        background: #f8fafc;
    }
`;

const VariantTools = styled.div`
    display: flex;
    gap: 8px;

    @media (max-width: 560px) {
        flex-direction: column;

        button {
            justify-content: center;
            width: 100%;
        }
    }
`;

const ToolButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #cbd5e1;
    background: #fff;
    color: #334155;
    border-radius: 8px;
    padding: 9px 12px;
    cursor: pointer;
    font-weight: 700;

    &:hover {
        border-color: #30d5c8;
        color: #0f766e;
    }
`;

const VariantList = styled.div`
    padding: 0 22px 22px;

    @media (max-width: 560px) {
        padding: 0 14px 14px;
    }
`;

const RequiredNote = styled.div`
    color: #b45309;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 14px;
    font-size: 13px;
    font-weight: 700;
`;

const VariantCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin-bottom: 14px;
    overflow: hidden;
`;

const VariantHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;

    h3 {
        margin: 0;
        color: #0f172a;
        font-size: 15px;
    }
`;

const IconButton = styled.button`
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #fecaca;
    background: #fff;
    color: #dc2626;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background: #fef2f2;
    }
`;

const CloneRow = styled.div`
    padding: 12px 16px 0;

    label {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #475569;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
    }
`;

const VariantGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(130px, 1fr));
    gap: 14px;
    padding: 16px;

    @media (max-width: 1000px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 560px) {
        grid-template-columns: 1fr;
    }
`;

const HsnFieldWrapper = styled.div`
    position: relative;
`;

const DynamicAttributesSection = styled.div`
    grid-column: 1 / -1;
    padding: 16px;
    border: 1px solid #dbeafe;
    border-radius: 12px;
    background: #f8fbff;
`;

const DynamicAttributeHeader = styled.div`
    margin-bottom: 14px;

    h3 {
        margin: 0 0 4px;
        color: #0f172a;
        font-size: 16px;
    }

    p {
        margin: 0;
        color: #64748b;
        font-size: 13px;
    }
`;

const HsnSuggestionCard = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 6px);
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 10px;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.14);
    padding: 12px 14px;
    z-index: 20;
`;

const HsnSuggestionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 4px;
`;

const HsnSuggestionCode = styled.span`
    font-weight: 700;
    color: #0f172a;
    font-size: 13px;
`;

const HsnSuggestionRate = styled.span`
    background: #ecfeff;
    color: #0f766e;
    font-weight: 700;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 999px;
    white-space: nowrap;
`;

const HsnSuggestionDescription = styled.div`
    font-size: 12px;
    color: #475569;
    line-height: 1.4;
    margin-bottom: 8px;
`;

const HsnSuggestionApplyButton = styled.button`
    border: 0;
    background: #0f766e;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background: #0d5f58;
    }
`;

const HsnAppliedNote = styled.div`
    margin-top: 6px;
    font-size: 12px;
    color: #0f766e;
`;

const VariantImageRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 16px 16px;
    overflow: hidden;

    @media (max-width: 560px) {
        align-items: stretch;
        flex-direction: column;
        padding: 0 14px 14px;
        overflow: visible;
    }
`;

const UploadTile = styled.label`
    min-width: 126px;
    height: 82px;
    border: 1px dashed #94a3b8;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    color: #475569;
    background: #f8fafc;
    flex-shrink: 0;

    @media (max-width: 560px) {
        width: 100%;
        min-width: 0;
    }

    &:hover {
        border-color: #30d5c8;
        color: #0f766e;
    }
`;

const ImagePreviewStrip = styled.div`
    display: flex;
    gap: 8px;
    overflow-x: auto;
    align-items: center;
    padding-bottom: 4px;
`;

const ImagePreview = styled.div`
    position: relative;
    min-width: 72px;
    height: 72px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    button {
        position: absolute;
        top: 4px;
        right: 4px;
        background: rgba(15, 23, 42, 0.78);
        color: #fff;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        font-size: 12px;
        cursor: pointer;
        line-height: 18px;
    }
`;

const AddVariantAction = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px dashed #14b8a6;
    background: #f0fdfa;
    color: #0f766e;
    padding: 11px 14px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 800;

    &:hover {
        background: #ccfbf1;
    }
`;
